<template>
  <div>
    <el-input
      class="answer--text--input"
      :disabled="disabled"
      type="textarea"
      autosize
      size="small"
      placeholder="请输入内容"
      @change="onChange"
      @input="onInput"
      v-model="answer.text">
    </el-input>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {
    answer: Object,
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({}),
  },
  watch: {},
  beforeCreate () {

  },
  created () {
    this.$nextTick(() => {})
  },
  mounted () {},
  methods: {
    onChange (val) {
      this.$emit('change', val)
    },
    onInput (val) {
      this.$emit('input', val)
    },
  },
}
</script>
<style lang="scss">
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/packages/AnswerText/index.vue